import React from 'react'
import { observer } from 'mobx-react-lite'
import { CustomTableStore, useCustomTableStore } from '../CustomTableStore'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import useCustomTableRenderLog from '../hooks/useCustomTableRenderLog'

export const CustomTableBodyNoResults = observer(<RowData extends AnyObject, RowStore>() => {
   const customTableStore = useCustomTableStore<CustomTableStore<RowData, RowStore>>()
   useCustomTableRenderLog('CustomTableBodyNoResults')

   if (customTableStore.rows.length === 0) {
      return (
         <Box textAlign="center" margin={3}>
            <Typography variant="subtitle2">
               {customTableStore.isLoading || customTableStore.waitingForRowsToCome
                  ? 'Loading...'
                  : 'No results to be displayed'}
            </Typography>
         </Box>
      )
   }
   return null
})
